import { cloneDeep } from 'lodash-es';

type TTrendEventDay = {
  date?: string;
  events?: number;
  event_list?: TTrendEventBlock[];
};

type TTrendEventBlock = {
  events?: number;
  event_record?: Array<Record<string, unknown>>;
  event_type?: unknown;
  [key: string]: unknown;
};

/** trim 后与 excludeEventTypes 全等匹配 */
export function normalizeExcludeEventTypes(
  types?: string[],
): Set<string> {
  if (!Array.isArray(types)) {
    return new Set();
  }
  const out = new Set<string>();
  types.forEach(t => {
    const s = String(t ?? '').trim();
    if (s) {
      out.add(s);
    }
  });
  return out;
}

/**
 * 与 excludeEventTypes 比对用的候选键：字符串直接返回；对象则收集 name_cn / name_en / name。
 */
export function collectEventTypeKeysForExclude(raw: unknown): string[] {
  if (raw === undefined || raw === null) {
    return [];
  }
  if (typeof raw === 'string') {
    const s = raw.trim();
    return s ? [s] : [];
  }
  if (typeof raw === 'object') {
    const o = raw as {
      name_cn?: unknown;
      name_en?: unknown;
      name?: unknown;
    };
    const keys: string[] = [];
    const cn = String(o.name_cn ?? '').trim();
    const en = String(o.name_en ?? '').trim();
    const name = String(o.name ?? '').trim();
    if (cn) {
      keys.push(cn);
    }
    if (en) {
      keys.push(en);
    }
    if (name) {
      keys.push(name);
    }
    return [...new Set(keys)];
  }
  const s = String(raw).trim();
  return s ? [s] : [];
}

export function isEventTypeExcluded(
  typeRaw: unknown,
  excludeSet: Set<string>,
): boolean {
  if (excludeSet.size === 0) {
    return false;
  }
  return collectEventTypeKeysForExclude(typeRaw).some(k => excludeSet.has(k));
}

function isEventRecordExcludedByEventTypes(
  record: Record<string, unknown>,
  excludeSet: Set<string>,
): boolean {
  return isEventTypeExcluded(record.event_type, excludeSet);
}

/**
 * 从 trend 按日列表中移除指定 event_type 的记录，并同步 block / 日级 events 计数。
 */
export function filterTrendEventListByExcludedEventTypes(
  list: unknown[] | undefined | null,
  excludeTypes: string[] | undefined,
): TTrendEventDay[] {
  const excludeSet = normalizeExcludeEventTypes(excludeTypes);
  if (!Array.isArray(list) || excludeSet.size === 0) {
    return (list || []) as TTrendEventDay[];
  }
  const cloned = cloneDeep(list) as TTrendEventDay[];
  cloned.forEach(day => {
    if (!day || !Array.isArray(day.event_list)) {
      return;
    }
    day.event_list = day.event_list
      .map(block => {
        if (!block || !Array.isArray(block.event_record)) {
          return block;
        }
        return {
          ...block,
          event_record: block.event_record.filter(
            r => !isEventRecordExcludedByEventTypes(r, excludeSet),
          ),
        };
      })
      .filter(
        block =>
          Array.isArray(block?.event_record) && block.event_record.length > 0,
      );
    let total = 0;
    day.event_list.forEach(block => {
      const n = Array.isArray(block.event_record) ? block.event_record.length : 0;
      block.events = n;
      total += n;
    });
    day.events = total;
  });
  return cloned;
}
